<template>
    <div>
        <div class="tabulation-title">
            <h5>
                <v-icon>label_outline</v-icon> Vos séjours
            </h5>
        </div>

        <v-alert type="info" text v-if="!disabled" class="mt-5 mb-5 form-container mr-auto ml-auto" border="right"
            colored-border>
            <div>
                Vous pouvez renseigner jusqu'à 3 séjours. Nous vous conseillons de renseigner un séjour best of,
                un séjour groupe (si possible) et un séjour moins connu
            </div>

            <div class="text-center">
                <v-btn class="default-button mt-3 mb-3" @click="openDialog" :disabled="products.length >= 3">
                    <v-icon>add</v-icon> Ajouter un séjour
                </v-btn>
            </div>
        </v-alert>

        <div class="d-flex justify-start medias-box flex-wrap products-container">
            <v-card v-for="(product, index) in products" class="mb-5 media-card" style="width: 300px">
                <v-app-bar dark color="primary">
                    <div class="d-flex justify-content-between w-100">
                        <div class="mt-auto mb-auto cmaj-title">
                            <span>{{ product.name }}</span>
                            <v-btn icon @click="editProduct(index)" v-if="!disabled">
                                <v-icon dense>edit</v-icon>
                            </v-btn>
                        </div>
                        <div>
                            <v-btn icon color="error" @click="deleteProduct(index)" v-if="!disabled">
                                <v-icon dense>delete</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </v-app-bar>

                <v-card-text>
                    <div :class="{'d-flex justify-content-between': product.thematicStays.length === 0}">
                        <span><b>Thématiques de séjour</b></span>

                        <div class="d-flex flex-wrap" v-if="product.thematicStays.length">
                            <v-chip class="m-1" v-for="item in product.thematicStays">
                                {{ item.label }}
                            </v-chip>
                        </div>
                        <div v-else>Non renseigné</div>
                    </div>

                    <div class="mt-1 d-flex justify-content-between">
                        <span><b>Nombre de jours</b></span>

                        <div v-if="product.dayNumber !== null && product.dayNumber !== ''">
                            {{ product.dayNumber }}
                        </div>
                        <div v-else>Non renseigné</div>
                    </div>

                    <div class="mt-1 d-flex justify-content-between">
                        <span><b>Nombre de nuits</b></span>

                        <div v-if="product.nightNumber !== null && product.nightNumber !== ''">
                            {{ product.nightNumber }}
                        </div>
                        <div v-else>Non renseigné</div>
                    </div>

                    <div class="mt-1 d-flex justify-content-between">
                        <span><b>Tel de réservation</b></span>

                        <div v-if="product.bookingPhone !== null && product.bookingPhone !== ''">
                            {{ product.bookingPhone }}
                        </div>
                        <div v-else>Non renseigné</div>
                    </div>

                    <div class="mt-1 d-flex justify-content-between">
                        <span><b>Email de réservation</b></span>

                        <div v-if="product.bookingEmail !== null && product.bookingEmail !== ''">
                            {{ product.bookingEmail }}
                        </div>
                        <div v-else>Non renseigné</div>
                    </div>

                    <div class="mt-1 d-flex justify-content-between">
                        <span><b>Tarif adulte</b></span>

                        <div v-if="product.adultPrice !== null && product.adultPrice !== ''">
                            À partir de {{ product.adultPrice }}&nbsp;€
                        </div>
                        <div v-else>Non renseigné</div>
                    </div>

                    <div class="mt-1 d-flex justify-content-between">
                        <span><b>Tarif enfant</b></span>

                        <div v-if="product.childPrice !== null && product.childPrice !== ''">
                            À partir de {{ product.childPrice }}&nbsp;€
                        </div>
                        <div v-else>Non renseigné</div>
                    </div>

                    <div :class="{'d-flex justify-content-between': product.customerTypes.length === 0}" class="mt-1">
                        <span><b>Type de clientèle</b></span>

                        <div class="d-flex flex-wrap" v-if="product.customerTypes.length">
                            <v-chip class="m-1" v-for="item in product.customerTypes">
                                {{ item.label }}
                            </v-chip>
                        </div>
                        <div v-else>Non renseigné</div>
                    </div>

                    <div :class="{'d-flex justify-content-between': product.coverTerritories.length === 0}"
                        class="mt-1">
                        <span><b>Territoire couvert</b></span>

                        <div class="d-flex flex-wrap" v-if="product.coverTerritories.length">
                            <v-chip class="m-1" v-for="item in product.coverTerritories">
                                {{ item.label }}
                            </v-chip>
                        </div>
                        <div v-else>Non renseigné</div>
                    </div>

                    <div :class="{'d-flex justify-content-between': product.languages.length === 0}" class="mt-1">
                        <span><b>Langues parlées</b></span>

                        <div class="d-flex flex-wrap" v-if="product.languages.length">
                            <v-chip class="m-1" v-for="item in product.languages">
                                {{ item.label }}
                            </v-chip>
                        </div>
                        <div v-else>Non renseigné</div>
                    </div>

                    <div class="mt-1 justify-content-between">
                        <div><b>Descriptif court FR</b></div>

                        <div v-if="product.descriptionFr !== null"
                            style=" text-overflow: ellipsis;white-space: nowrap;overflow: hidden;width: 100%;">
                            {{ product.descriptionFr }}
                        </div>
                        <div v-else>Non renseigné</div>
                    </div>

                    <div class="mt-1 justify-content-between">
                        <div><b>Descriptif court EN</b></div>

                        <div v-if="product.descriptionEn !== null"
                            style=" text-overflow: ellipsis;white-space: nowrap;overflow: hidden;width: 100%;">
                            {{ product.descriptionEn }}
                        </div>
                        <div v-else>Non renseigné</div>
                    </div>

                    <div class="mt-1 justify-content-between">
                        <div><b>Descriptif long FR</b></div>

                        <div v-if="product.descriptionFrLong !== null"
                            style=" text-overflow: ellipsis;white-space: nowrap;overflow: hidden;width: 100%;">
                            {{ product.descriptionFrLong }}
                        </div>
                        <div v-else>Non renseigné</div>
                    </div>

                    <div class="mt-1 justify-content-between">
                        <div><b>Descriptif long EN</b></div>

                        <div v-if="product.descriptionEnLong !== null"
                            style=" text-overflow: ellipsis;white-space: nowrap;overflow: hidden;width: 100%;">
                            {{ product.descriptionEnLong }}
                        </div>
                        <div v-else>Non renseigné</div>
                    </div>

                    <div class="mt-1 d-flex justify-content-between">
                        <span><b>Photos</b></span>

                        <div v-if="product.photos.length > 0">
                            {{ product.photos.length }} photo(s)
                        </div>
                        <div v-else>Non renseigné</div>
                    </div>

                    <div class="mt-1 d-flex justify-content-between">
                        <span><b>Documents</b></span>

                        <div v-if="product.documents.length > 0">
                            {{ product.documents.length }} document(s)
                        </div>
                        <div v-else>Non renseigné</div>
                    </div>

                    <div class="mt-1 d-flex justify-content-between">
                        <span><b>Liens</b></span>

                        <div v-if="linkCount(product) > 0">
                            {{ linkCount(product) }} lien(s)
                        </div>
                        <div v-else>Non renseigné</div>
                    </div>
                </v-card-text>
            </v-card>
        </div>

        <v-dialog v-model="createProductDialog" v-if="createProductDialog" persistent ref="dialog" fullscreen
            hide-overlay transition="dialog-bottom-transition">
            <v-toolbar dark color="primary">
                <v-toolbar-title>Ajout d'un séjour</v-toolbar-title>

                <div class="text-right w-100">
                    <v-btn icon dark @click="closeDialog">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>
            </v-toolbar>

            <v-card>
                <div id="webform">
                    <div class="col-7 mr-auto ml-auto pt-5 webform-container">
                        <div class="tabulation-title">
                            <h5>
                                <v-icon>label_outline</v-icon> Informations générales
                            </h5>
                        </div>

                        <v-text-field label="Titre du séjour" autocomplete="new-offer-name"
                            v-model="currentProduct.name" outlined>
                        </v-text-field>

                        <v-autocomplete :items="communes" :value="currentProduct.commune"
                            label="Commune de départ de votre séjour" item-text="name" class="mt-5"
                            v-model="currentProduct.commune" return-object :loading="loadingCommunes"
                            :search-input.sync="searchCommunes" no-data-text="Saisissez pour sélectionner une ville"
                            outlined>
                        </v-autocomplete>

                        <v-autocomplete :items="thematicStays" chips v-model="currentProduct.thematicStays"
                            deletable-chips label="Thématiques de séjours proposées par l'agence" item-text="label"
                            return-object class="mt-5" multiple outlined>
                        </v-autocomplete>

                        <div class="d-flex mt-5">
                            <div class="col-6 pl-0 pt-0 pb-0">
                                <v-text-field v-model="currentProduct.dayNumber" label="Nombre de jours" type="number"
                                    outlined>
                                </v-text-field>
                            </div>

                            <div class="col-6 pr-0 pt-0 pb-0">
                                <v-text-field v-model="currentProduct.nightNumber" label="Nombre de nuits" type="number"
                                    outlined>
                                </v-text-field>
                            </div>
                        </div>

                        <v-text-field label="Tel de réservation" v-model="currentProduct.bookingPhone" class="mt-5"
                            :class="{'input-error': checkPhoneFormat(currentProduct.bookingPhone) !== ''}" outlined>
                        </v-text-field>

                        <div class="txt-error mt-1">
                            {{ checkPhoneFormat(currentProduct.bookingPhone) }}
                        </div>

                        <v-text-field label="Email de réservation" class="mt-5"
                            :class="{'input-error': checkEmailFormat(currentProduct.bookingEmail) !== ''}"
                            v-model="currentProduct.bookingEmail" outlined>
                        </v-text-field>

                        <div class="txt-error mt-1">
                            {{ checkEmailFormat(currentProduct.bookingEmail) }}
                        </div>

                        <div class="tabulation-title mt-5">
                            <h5>
                                <v-icon>label_outline</v-icon> Descriptifs du séjour
                            </h5>
                        </div>

                        <v-alert type="info" text class="mt-5 mb-5 form-container mr-auto ml-auto" border="right"
                            colored-border>
                            <div>Ces informations s'adressent à une cible professionnelle BtoB</div>
                        </v-alert>

                        <div class="tabulation-title ml-5 mt-5">
                            <h5 style="font-size: 15px">
                                <v-icon>label_outline</v-icon> Descriptif général du séjour
                            </h5>
                        </div>

                        <v-textarea class="textarea mt-5" counter v-model="currentProduct.descriptionFr" maxlength="255"
                            outlined>
                            <template v-slot:label>
                                Descriptif court <img :src="'/images/flags/fr.png'" height="20px">
                            </template>
                        </v-textarea>

                        <v-textarea class="textarea mt-5" counter v-model="currentProduct.descriptionEn" maxlength="255"
                            outlined>
                            <template v-slot:label>
                                Descriptif court <img :src="'/images/flags/en.png'" height="20px">
                            </template>
                        </v-textarea>

                        <div class="tabulation-title ml-5">
                            <h5 style="font-size: 15px">
                                <v-icon>label_outline</v-icon> Descriptif détaillé du séjour
                            </h5>
                        </div>

                        <v-alert type="info" text class="mt-5 mb-5 form-container mr-auto ml-auto" border="right"
                            colored-border>
                            <div>Merci de préciser le programme détaillé de votre séjour (ex: Jour 1, Jour 2, Jour 3,
                                etc.)</div>
                        </v-alert>

                        <v-textarea class="textarea mt-5" v-model="currentProduct.descriptionFrLong" outlined>
                            <template v-slot:label>
                                Descriptif détaillé <img :src="'/images/flags/fr.png'" height="20px">
                            </template>
                        </v-textarea>

                        <v-textarea class="textarea mt-5" v-model="currentProduct.descriptionEnLong" outlined>
                            <template v-slot:label>
                                Descriptif détaillé <img :src="'/images/flags/en.png'" height="20px">
                            </template>
                        </v-textarea>

                        <div class="tabulation-title">
                            <h5>
                                <v-icon>label_outline</v-icon> Tarifs
                            </h5>
                        </div>

                        <div class="d-flex periods mt-4">
                            <div class="col-6 pl-0 pt-0 pb-0 price-input-container d-flex">
                                <v-text-field label="Tarif enfant (à partir de)" v-model="currentProduct.childPrice"
                                    type="number" outlined>
                                </v-text-field>

                                <div class="currency">€</div>
                            </div>

                            <div class="col-6 pr-0 pt-0 pb-0 price-input-container d-flex">
                                <v-text-field label="Tarif adulte (à partir de)" v-model="currentProduct.adultPrice"
                                    type="number" outlined>
                                </v-text-field>

                                <div class="currency">€</div>
                            </div>
                        </div>

                        <div class="tabulation-title">
                            <h5>
                                <v-icon>label_outline</v-icon> Spécificités du séjour
                            </h5>
                        </div>

                        <v-autocomplete :items="customerTypes" chips v-model="currentProduct.customerTypes"
                            deletable-chips label="Type de clientèle" item-text="label" return-object multiple outlined>
                        </v-autocomplete>

                        <v-autocomplete :items="territories" chips v-model="currentProduct.coverTerritories"
                            deletable-chips label="Territoire couvert" item-text="label" return-object class="mt-5"
                            multiple outlined>
                        </v-autocomplete>

                        <v-autocomplete chips deletable-chips v-model="currentProduct.languages" :items="languages"
                            label="Langues parlées" item-text="label" return-object class="mt-5 mb-5" multiple outlined>
                        </v-autocomplete>

                        <product-media :disabled="false"></product-media>
                        <product-file :disabled="false"></product-file>
                        <aura-link></aura-link>

                        <div class="mt-5 mb-5 valid-button"
                            v-if="currentProduct.commune === null || currentProduct.name === null || currentProduct.photos.length < 3">

                            <div class="title-valid-button">
                                <v-icon color="warning">warning</v-icon> Informations obligatoires
                            </div>

                            <div class="mt-3" v-if="currentProduct.name === null">
                                La titre de votre séjour est requis.
                            </div>

                            <div class="mt-3" v-if="currentProduct.commune === null">
                                La commune de départ de votre séjour est requise.
                            </div>

                            <div class="mt-3" v-if="currentProduct.photos.length < 3">
                                Vous devez renseigner 3 photos au minimum sur votre séjour <b>({{ photoNeededNumber }}
                                    manquante(s))</b>
                            </div>
                        </div>

                        <div class="d-flex justify-content-between mt-5 mb-5">
                            <v-btn color="error" @click="closeDialog">Annuler</v-btn>

                            <v-btn class="default-button" v-if="!editMode"
                                :disabled="currentProduct.commune === null || currentProduct.name === null || currentProduct.photos.length < 3"
                                @click="addProduct">
                                Ajouter
                            </v-btn>

                            <v-btn class="default-button" v-else
                                :disabled="currentProduct.commune === null || currentProduct.name === null || currentProduct.photos.length < 3"
                                @click="closeDialog">
                                Enregistrer
                            </v-btn>
                        </div>
                    </div>
                </div>
            </v-card>
        </v-dialog>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import ProductMedia from "./ProductMedia"
import ProductFile from "./ProductFile";
import AuraLink from "@/components/aura/AuraLink"
import _ from "lodash"
import Confirm from "../tools/Confirm"
import PhoneNumber from "awesome-phonenumber";
import * as EmailValidator from "email-validator";

export default {
    name: "PackagedProducts",
    components: { Confirm, AuraLink, ProductFile, ProductMedia },
    props: ['languages', 'disabled'],
    data() {
        return {
            createProductDialog: false,
            communes: [],
            loadingCommunes: false,
            searchCommunes: null,
            thematicStays: [
                {
                    label: 'Bien-être',
                    value: 20143
                },
                {
                    label: 'Ville et Culture',
                    value: 20144
                },
                {
                    label: 'Gastronomie & oenotourisme',
                    value: 20145
                },
                {
                    label: 'Neige / hiver',
                    value: 20146
                },
                {
                    label: 'Outdoor / itinérance',
                    value: 10147
                },
                {
                    label: 'Ecotourisme',
                    value: 20148
                }
            ],
            customerTypes: [
                {
                    label: 'Individuel / FIT',
                    value: 5737
                },
                {
                    label: 'Groupe',
                    value: 593
                },
                {
                    label: 'Affaires / MICE',
                    value: 597
                }
            ],
            territories: [
                {
                    label: 'Ardèche & Drôme (vallée du Rhône)',
                    value: 6481
                },
                {
                    label: 'Auvergne',
                    value: 6478
                },
                {
                    label: 'Les Alpes (dont l\'Isère)',
                    value: 6479
                },
                {
                    label: 'Lyon et ses alentours (Vienne, Ain, Saint-Etienne, Beaujolais)',
                    value: 6480
                },
                {
                    label: 'Vallée de la Gastronomie',
                    value: 6482
                }
            ]
        }
    },
    methods: {
        ...mapMutations('aura', ['setCurrentProduct', 'setDefaultProduct', 'pushProduct', 'setEditMode']),
        openDialog() {
            this.setDefaultProduct()
            this.setEditMode(false)

            document.documentElement.classList.add('overflow-y-hidden')

            this.createProductDialog = true
        },
        closeDialog() {
            this.createProductDialog = false
        },
        addProduct() {
            this.pushProduct(this.currentProduct)

            this.setDefaultProduct()

            this.createProductDialog = false
        },
        getCommunes: _.debounce(function () {
            this.loadingCommunes = true

            let payload = {
                search: this.searchCommunes
            }

            this.$http.post('resource/communes', payload).then(res => {
                this.communes = res.body.data.communes

                this.loadingCommunes = false
            })
        }, 500),
        editProduct(index) {
            this.setCurrentProduct(this.products[index])
            this.setEditMode(true)

            this.communes.push(this.currentProduct.commune)

            document.documentElement.classList.add('overflow-y-hidden')

            this.createProductDialog = true
        },
        deleteProduct(index) {
            this.$refs.confirm.open('Attention',
                'Êtes-vous sûr de vouloir supprimer ce séjour ?',
                { color: 'red' }).
                then((confirm) => {
                    if (confirm) {
                        this.products.splice(index, 1)
                    }
                })
        },
        linkCount(product) {
            return product.links.filter(link => link.value !== null && link.value !== '').length
        },
        checkPhoneFormat(phone) {
            let result = ''

            if (phone !== null) {
                let phoneFr = new PhoneNumber(phone, 'FR')
                let phoneNc = new PhoneNumber(phone, 'NC')
                let phoneCAN = new PhoneNumber(phone, 'CA')

                result = (phoneFr.isValid() || phoneNc.isValid() || phoneCAN.isValid()) ?
                  '' : 'Le format du téléphone n\'est pas correct'
            }

            return result
        },
        checkEmailFormat(email) {
            let result = ''

            if (email !== null) {
                let isValidEmail = EmailValidator.validate(email)
                result = isValidEmail ? '' : 'Le format de l\'email n\'est pas correct'
            }

            return result
        }
    },
    computed: {
        ...mapState('aura', ['currentProduct', 'products', 'editMode']),
        validLinkNumbers() {
            return this.currentProduct.links.map(link => link.value !== '' && link.value !== null).length
        },
        photoNeededNumber() {
            return 3 - this.currentProduct.photos.length
        }
    },
    watch: {
        searchCommunes() {
            this.searchCommunes = this.searchCommunes.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase()

            this.getCommunes()
        }
    }
}
</script>

<style scoped>
#webform {
    background-color: #f5f5f5;
}

.webform-container {
    background-color: white;
    padding: 40px !important;
}

.periods {
    margin-top: 10px;
    margin-bottom: 30px;
}

.periods .v-input:not(.textarea) {
    padding-top: 0 !important;
    max-width: calc(100%) !important;
}

.periods .currency {
    position: absolute;
    right: 0;
    height: 41px !important;
    top: -3px;
    border-left: solid #9e9e9e 1px !important;
}

.tabulation-title i {
    color: #29B6F6 !important;
}

.products-container .v-chip__content,
.products-container span,
.products-container div {
    font-size: 13px;
}

.products-container .v-card {
    background-color: #fbf8ef !important;
}

.v-chip.v-size--default {
    height: 22px !important;
}

.v-toolbar__content span {
    font-size: 15px !important;
}
</style>
